import { useEffect, useMemo, useState } from 'react'
import {
  Mask,
  Popover,
  Arrow,
  HelpMask,
  StepOneBox,
  StepTitle,
  StepIntro,
  StepOneDesc,
  StepLink,
  Close,
  StepFooter,
  StepBackButton,
  StepNextButton,
  StepTwoNetsList,
  NetworkIcon,
  NetworkOption,
  TextOverFlow,
  StepHeader,
  StepTwoBox,
  // Warning,
  // ActiveStepOne,
  // ActiveStepTitle,
  // ActiveStepDesc,
  // ActiveItemBox,
  // DepositeFrom,
  // ActiveAccountItemBox,
  // ActiveButton,
} from './styles'
import { useSupportChains } from 'store/app/hooks'
import { debounce } from 'lodash'
import { getDomRectPos, ELEMENT_ID_LIST, getElement, LINK } from './uitls'
// import { ReactComponent as SvgWarning } from './assets/warning.svg'
// import { ReactComponent as SvgDeposite } from './assets/deposite.svg'
// import { ReactComponent as SvgWallet } from './assets/wallet.svg'
// import { ReactComponent as SvgQrCode } from './assets/qrcode.svg'
// import { ReactComponent as SvgUser } from './assets/user.svg'
// import { ReactComponent as SvgActive } from './assets/active.svg'
import { ReactComponent as SvgClose } from './assets/arrow.svg'
import ContentPNG from './assets/content.png'
import { updateGuideText } from 'store/app/actions'
// import { useIsActivated } from 'store/account/hooks'
import { useAppDispatch } from 'store'

interface IAnchor {
  top: number
  left: number
  bottom: number
  width: number
  height: number
  right: number
  centerX: number
  centerY: number
}

export const AccountAcitveGuide = () => {
  const supportChains = useSupportChains()

  const [anchorRectPosList, setAnchorRectPosList] = useState<IAnchor[]>([])
  const [step, setStep] = useState(0)
  const [showGuide, setShowGuide] = useState(false)
  const dispatch = useAppDispatch()
  // const isActivated = useIsActivated()

  const handleClose = () => {
    localStorage.setItem('zkex_v3_open_account_guide', '1')
    setShowGuide(false)
  }

  useEffect(() => {
    const alreadyShow = localStorage.getItem('zkex_v3_open_account_guide')
    if (!alreadyShow) {
      setShowGuide(true)
    } else {
      setShowGuide(false)
    }
  }, [])

  const handleCalcElemntsPos = () => {
    const list: Array<IAnchor> = []
    try {
      ELEMENT_ID_LIST.forEach((id) => {
        const dom = getElement(id) as HTMLElement
        if (dom) {
          const style = getDomRectPos(dom)
          list.push(style)
        } else {
          throw new Error(`id: ${id} dom dose not exit`)
        }
      })
      setAnchorRectPosList(list)
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    const nav_wrap = getElement('zk_nav_wrap') as HTMLElement
    const spot_wrap = (getElement('zk_spot_wrap') ||
      getElement('zk_perp_wrap')) as HTMLElement
    if (showGuide) {
      nav_wrap.style.position = 'relative'
      spot_wrap.style.padding = '0px 0px 24px'

      if (step === 2) {
        dispatch(updateGuideText('Open My Account'))
      }
    } else {
      nav_wrap.style.position = 'fixed'
      spot_wrap.style.padding = '64px 0 24px'
      dispatch(updateGuideText(''))
    }
  }, [showGuide, step])

  // realtime computing position
  useEffect(() => {
    const debouncedHandle = debounce(handleCalcElemntsPos)
    window.addEventListener('resize', debouncedHandle, false)
    return () => window.removeEventListener('resize', debouncedHandle)
  }, [])

  useEffect(() => {
    const nav_wrap = getElement('zk_nav_wrap') as HTMLElement
    const spot_wrap = (getElement('zk_spot_wrap') ||
      getElement('zk_perp_wrap')) as HTMLElement
    setTimeout(() => {
      handleCalcElemntsPos()
    }, 500)
    return () => {
      nav_wrap.style.position = 'fixed'
      spot_wrap.style.padding = '64px 0 24px'
    }
  }, [])

  const stepRectPos = useMemo(() => {
    if (anchorRectPosList.length > 0) {
      return anchorRectPosList[step] as IAnchor
    }
    // @ts-ignore
    return {} as IAnchor
  }, [anchorRectPosList, step])

  const CloseBtn = () => {
    return <Close onClick={() => handleClose()} />
  }

  const renderStepButton = () => {
    const _next = canNext(step)
    const _back = canBack(step)
    return (
      <StepFooter>
        {step !== 0 && (
          <StepBackButton
            className={_back ? 'active' : ''}
            onClick={() => {
              if (_back) {
                setStep(step - 1)
              }
            }}
          >
            <SvgClose />
            Back
          </StepBackButton>
        )}

        {step !== 2 && (
          <StepNextButton
            className={_next ? 'active' : ''}
            onClick={() => {
              if (_next) {
                setStep(step + 1)
              }
            }}
          >
            Next
            <SvgClose />
          </StepNextButton>
        )}

        {step === 2 && (
          <StepNextButton
            className="finished"
            onClick={() => {
              handleClose()
            }}
          >
            Finished!
          </StepNextButton>
        )}
      </StepFooter>
    )
  }

  const canBack = (currStep: number) => {
    if (currStep <= 0) {
      return false
    }
    return true
  }

  const canNext = (currStep: number) => {
    if (currStep < 3) {
      return true
    }
    return false
  }

  // Guide Steps
  const GUIDE_STEPS = [
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <>
            <Popover
              style={{
                top: currRectPos?.bottom + 15,
                left: currRectPos?.centerX - 180,
              }}
            >
              <Arrow className="top"></Arrow>
              <StepOneBox>
                <StepHeader>
                  <StepTitle>Connect Your Wallet</StepTitle>
                  <StepIntro>
                    <span>1 / 3</span>
                    <CloseBtn />
                  </StepIntro>
                </StepHeader>
                <StepOneDesc>
                  Your wallet is your account! We use it to facilitate smooth
                  interactions with ZKEX smart contracts.
                </StepOneDesc>
                <StepLink href={LINK[0]} target="_blank">
                  Learn more about wallets
                </StepLink>
                {renderStepButton()}
              </StepOneBox>
            </Popover>
          </>
        )
      },
    },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <>
            <Popover
              style={{
                top: currRectPos.bottom + 15,
                left: currRectPos.centerX - 280,
              }}
            >
              <Arrow className="top" style={{ left: '80%' }}></Arrow>
              <StepTwoBox>
                <StepHeader>
                  <StepTitle>Select Network</StepTitle>
                  <StepIntro>
                    <span>2 / 3</span>
                    <CloseBtn />
                  </StepIntro>
                </StepHeader>

                {/* <FlexBetween>
                  <FlexStart>
                    <StepTitle>Select NetWork</StepTitle>
                    <StepIntro>(2/3)</StepIntro>
                  </FlexStart>
                  <CloseBtn />
                </FlexBetween> */}
                {/* <StepDesc>
                Click to switch between 15 integrated networks.
              </StepDesc> */}
                <StepTwoNetsList>
                  {supportChains?.map((item) => {
                    return (
                      <NetworkOption key={item.chainId}>
                        <NetworkIcon src={item.iconUrl} />
                        <TextOverFlow>{item.name}</TextOverFlow>
                      </NetworkOption>
                    )
                  })}
                </StepTwoNetsList>
                <StepOneDesc>
                  Click to switch between 15 integrated networks.
                </StepOneDesc>
                <StepLink href={LINK[1]} target="_blank">
                  Learn more about networks
                </StepLink>
                {renderStepButton()}
              </StepTwoBox>
            </Popover>
          </>
        )
      },
    },
    {
      popover: (currRectPos: IAnchor) => {
        return (
          <Popover
            style={{ top: currRectPos.top - 250, left: currRectPos.left - 360 }}
          >
            <Arrow className="right" style={{ top: '250px' }}></Arrow>

            <StepOneBox>
              <StepHeader>
                <StepTitle>Open Your ZKEX Account</StepTitle>
                <StepIntro>
                  <span>3 / 3</span>
                  <CloseBtn />
                </StepIntro>
              </StepHeader>
              {/* <Warning>
                <SvgWarning />
                <span>Account are activated after a successful deposit.</span>
              </Warning> */}
              {/* <ActiveStepOne>
                <div className="tag line">1</div>
                <div className="box-left">
                  <ActiveStepTitle>
                    Deposit assets into your ZKEX account
                  </ActiveStepTitle>
                  <ActiveStepDesc>
                    Select one of the following options to deposit.
                  </ActiveStepDesc>
                  <DepositeFrom>
                    <span>Deposit from Wallet</span>
                    <SvgDeposite />
                  </DepositeFrom>
                  <ActiveItemBox>
                    <SvgWallet />
                    <div className="right">
                      <span className="title">
                        Transfer crypto from personal wallet
                      </span>
                      <span className="desc">
                        Deposit funds to your ZKEX account from any connected
                        chain.
                      </span>
                    </div>
                  </ActiveItemBox>
                  <ActiveItemBox>
                    <SvgQrCode />
                    <div className="right">
                      <span className="title">
                        Transfer crypto from personal wallet
                      </span>
                      <span className="desc">
                        Deposit funds to your ZKEX account from any connected
                        chain.
                      </span>
                    </div>
                  </ActiveItemBox>
                </div>
              </ActiveStepOne>
              <ActiveStepOne style={{ marginTop: '24px' }}>
                <div className="tag">2</div>
                <div className="box-left">
                  <ActiveStepTitle>Activate Account</ActiveStepTitle>
                  <ActiveStepDesc>
                    Sign the wallet signature to activate your account.
                  </ActiveStepDesc>
                  <ActiveAccountItemBox>
                    <div className="left">
                      <SvgUser />
                      <div className="content">
                        <span className="title">Enable trading</span>
                        <span className="desc">
                          Activate your ZKEX account on layer 2
                        </span>
                      </div>
                    </div>
                    <div className="right">
                      <ActiveButton>
                        <SvgActive />
                        <span>Activate</span>
                      </ActiveButton>
                    </div>
                  </ActiveAccountItemBox>
                </div>
              </ActiveStepOne> */}
              <img src={ContentPNG} style={{ marginTop: '16px' }} alt="" />
              <StepLink
                href={LINK[2]}
                target="_blank"
                style={{ marginLeft: '28px' }}
              >
                Learn more about how ZKEX works
              </StepLink>
              {renderStepButton()}
            </StepOneBox>
          </Popover>
        )
      },
    },
  ]

  const maskHeight = (document.querySelector('#root') as HTMLElement)
    .clientHeight
  return (
    <>
      {showGuide && (
        <Mask height={maskHeight}>
          {step >= 0 && stepRectPos.width > 0 && (
            <HelpMask
              style={{
                width: stepRectPos.width,
                height: stepRectPos.height,
                left: stepRectPos.left,
                top: stepRectPos.top,
              }}
            ></HelpMask>
          )}
        </Mask>
      )}

      {stepRectPos?.width >= 0 &&
        showGuide &&
        GUIDE_STEPS[step]?.popover(stepRectPos)}
    </>
  )
}
